var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.319,
    height: 161.064,
    viewBox: "0 0 181.319 161.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#c9c9c9;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M441.3,6089.828a16.579,16.579,0,0,1-5.7-12.46,18.476,18.476,0,0,1,5.7-13.527q18.51-19.225,23.5-47.7-15.665-1.423-25.989-11.748t-10.324-26.7q0-17.8,11.037-29.192t27.412-11.392q17.8,0,28.836,13.883T506.8,5992.64q0,56.248-36.312,94.7-7.12,7.831-16.375,7.832A18.272,18.272,0,0,1,441.3,6089.828Zm-100,0a16.579,16.579,0,0,1-5.7-12.46,18.476,18.476,0,0,1,5.7-13.527q18.512-19.225,23.5-47.7-15.665-1.423-25.988-11.748t-10.324-26.7q0-17.8,11.035-29.192t27.412-11.392q17.8,0,28.836,13.883T406.8,5992.64q0,56.248-36.313,94.7-7.12,7.831-16.375,7.832A18.272,18.272,0,0,1,341.3,6089.828Z",
    transform: "translate(-326.985 -5935.604)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.dc4107e2afcbc0ab5c29c6e271fb5671.svg";
export { ForwardRef as ReactComponent };